import { superToggle } from '../../_common/js/_helpers/super-toggle';
import { mobileCheck } from '../../_common/js/_helpers/mobile-check';

window.addEventListener('load', event => {
    let floorplanWrapper = document.getElementsByClassName('floorplan-switcher-wrapper');
    if (floorplanWrapper.length) {
        let checkMobile = mobileCheck(); // Call mobileCheck after window has loaded

        /*********************************************************
         *
         * Generic toggle switcher js
         * Author: Eamon McKiernan
         *
         * ********************************************************/

        let switchers = document.getElementsByClassName('toggle-switches');

        for ( let switcher of switchers ) {
            let upperToggle = switcher.getElementsByClassName('upper-toggle')[0]; // Only supports 1 button
            let lowerToggle = switcher.getElementsByClassName('lower-toggle')[0]; // Only supports 1 button

            let associatedSwitcher = switcher.dataset.switcher;
            for ( let floorplan of floorplanWrapper ) {
                if (floorplan.dataset.switcher === associatedSwitcher) {
                    let groundFloorplanWrapper = floorplan.getElementsByClassName('ground-floorplan-wrapper')[0]; // Only supports 1 switcher
                    let upperFloorplanWrapper = floorplan.getElementsByClassName('upper-floorplan-wrapper')[0]; // Only supports 1 switcher

                    if (upperToggle && lowerToggle && groundFloorplanWrapper && upperFloorplanWrapper) {
                        upperToggle.addEventListener('click', () => {
                            upperToggle.classList.add('shadow-inner-shadow', 'pointer-events-none');
                            lowerToggle.classList.remove('shadow-inner-shadow', 'pointer-events-none');
                            groundFloorplanWrapper.classList.add('opacity-0');
                            upperFloorplanWrapper.classList.remove('opacity-0');
                        });

                        lowerToggle.addEventListener('click', () => {
                            lowerToggle.classList.add('shadow-inner-shadow', 'pointer-events-none');
                            upperToggle.classList.remove('shadow-inner-shadow', 'pointer-events-none');
                            groundFloorplanWrapper.classList.remove('opacity-0');
                            upperFloorplanWrapper.classList.add('opacity-0');
                        });
                    }
                }
            }
        }

        /*********************************************************
         *
         * Floorplan zoom / fullscreen js
         * Author: Eamon McKiernan
         *
         * ********************************************************/

        let zoomIn = document.getElementById('zoomIn');
        let zoomOut = document.getElementById('zoomOut');
        let zoomButtonsWrapper = document.getElementById('zoomButtonsWrapper');
        let fullScreen = document.getElementById('fullScreen');
        let floorplanModal = document.getElementById('floorplanModal');

        // Master floorplan wrapper, used multiple times
        let movableItem = document.querySelector("#floorplanSwitcherWrapper");
        let container = document.querySelector("#containerWrapper"); // Floorplan container

        // Desktop show zoom buttons
        if (!checkMobile) {
            if (zoomIn && zoomOut && zoomButtonsWrapper && floorplanModal) {
                let fullscreenText = document.querySelector('.fullscreen-text');

                setTimeout(function () {
                    floorplanModal.classList.remove('pointer-events-none');
                    zoomIn.classList.remove('hidden');
                    zoomOut.classList.remove('hidden');
                    fullScreen.classList.remove('!border-0');
                    zoomButtonsWrapper.classList.remove('!border-0');

                    if (fullscreenText) {
                        fullscreenText.classList.add('hidden');
                    }
                }, 2);
            }
        }

        let newScale = 1;
        let zoom = 0.2;
        let mobileZoom = zoom * 10;
        let scrollY; // Store the window scroll posiiton for the full screen modal
        let open = false;

        if (movableItem) {
            if (zoomIn) {
                zoomIn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (checkMobile) {
                        pz.zoomIn(mobileZoom);
                        ;
                    }
                    else {
                        let transform = movableItem.style.transform.replace(/scale\(([^,]+)[^)]*\)/g, '');
                        let scale = parseFloat(movableItem.style.transform.replace(/translate3d\(([^,]+)[^)]*\)/g, '').replace('scale(', '').replace(')', ''));

                        if (transform && scale) {
                            newScale = scale + zoom;
                            movableItem.style.transform = transform + ' scale(' + newScale + ')';
                        }
                        else if (scale) {
                            newScale = scale + zoom;
                            movableItem.style.transform = 'scale(' + newScale + ')';
                        }
                        else {
                            movableItem.style.transform = 'scale(' + (1 + zoom) + ')';
                        }
                    }
                });
            }

            if (zoomOut) {
                zoomOut.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (checkMobile) {
                        pz.zoomOut(mobileZoom);
                    }
                    else {
                        let transform = movableItem.style.transform.replace(/scale\(([^,]+)[^)]*\)/g, '');
                        let scale = parseFloat(movableItem.style.transform.replace(/translate3d\(([^,]+)[^)]*\)/g, '').replace('scale(', '').replace(')', ''));

                        if (transform && scale) {
                            newScale = scale - zoom;
                            movableItem.style.transform = transform + ' scale(' + newScale + ')';
                        }
                        else if (scale) {
                            newScale = scale - zoom;
                            movableItem.style.transform = 'scale(' + newScale + ')';
                        }
                        else {
                            movableItem.style.transform = 'scale(' + (1 - zoom) + ')';
                        }
                    }
                });
            }

            if (fullScreen && floorplanModal && container && movableItem && zoomIn && zoomOut && zoomButtonsWrapper) {
                fullScreen.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    let fullscreenIcon = document.querySelector('.fullscreen-icon');
                    let floorplanCross = document.querySelector('.floorplan-cross');
                    let fullscreenText = document.querySelector('.fullscreen-text');

                    if (open) {
                        // restore scroll position
                        setTimeout(function () {
                            window.scrollTo(0, scrollY);
                        }, 2); // In timeout as scrollTo won't work otherwise
                        open = false;
                        enableBodyScroll(container);

                        if (checkMobile) {
                            pz.zoomReset();
                        }
                        else {
                            let transform = movableItem.style.transform.replace(/scale\(([^,]+)[^)]*\)/g, '');
                            movableItem.style.transform = transform + ' scale(1)';
                        }

                    }
                    else {
                        // remember scroll position
                        scrollY = window.scrollY;
                        open = true;
                        disableBodyScroll(container);
                        setTimeout(function () {
                            window.scrollTo(0, 0);
                        }, 2); // In timeout as scrollTo won't work otherwise
                    }

                    let classes = ['bg-lavalle-pearl-1', 'w-screen', 'h-screen', 'z-100', 'inset-0', '!fixed', 'max-h-screen', 'max-h-screen-safari-fix'];
                    superToggle(floorplanModal, classes);

                    if (fullscreenIcon && floorplanCross) {
                        let iconClasses = ['opacity-0', 'pointer-events-none'];
                        superToggle(fullscreenIcon, iconClasses);
                        superToggle(floorplanCross, iconClasses);
                        superToggle(container, ['flex', 'h-full']);
                    }

                    if (checkMobile) {
                        if (fullscreenText) {
                            superToggle(fullscreenText, ['hidden']);
                        }

                        superToggle(zoomIn, ['hidden']);
                        superToggle(zoomOut, ['hidden']);
                        superToggle(fullScreen, ['!border-0']);
                        superToggle(zoomButtonsWrapper, ['!border-0']);
                        superToggle(floorplanModal, ['pointer-events-none']);
                    }

                    document.documentElement.classList.toggle('body-lock-scroll-modal');
                });
            }
        }


        /*********************************************************
         *
         * Desktop drag and drop js
         * Author: Eamon McKiernan
         *
         * ********************************************************/

        let dragItem = document.querySelector("#clickDragWrapper");

        let active = false;
        let currentX;
        let currentY;
        let initialX;
        let initialY;
        let xOffset = 0;
        let yOffset = 0;

        if (!checkMobile) {
            container.addEventListener("touchstart", dragStart, false);
            container.addEventListener("touchend", dragEnd, false);
            container.addEventListener("touchmove", drag, false);

            container.addEventListener("mousedown", dragStart, false);
            container.addEventListener("mouseup", dragEnd, false);
            container.addEventListener("mousemove", drag, false);
        }

        function dragStart(e) {
            if (e.type === "touchstart") {
                initialX = e.touches[0].clientX - xOffset;
                initialY = e.touches[0].clientY - yOffset;
            }
            else {
                initialX = e.clientX - xOffset;
                initialY = e.clientY - yOffset;
            }

            if (e.target === dragItem) {
                active = true;
            }
        }

        function dragEnd(e) {
            initialX = currentX;
            initialY = currentY;

            active = false;
        }

        function drag(e) {

            if (active) {

                e.preventDefault();

                if (e.type === "touchmove") {
                    currentX = e.touches[0].clientX - initialX;
                    currentY = e.touches[0].clientY - initialY;
                }
                else {
                    currentX = e.clientX - initialX;
                    currentY = e.clientY - initialY;
                }

                xOffset = currentX;
                yOffset = currentY;

                setTranslate(currentX, currentY, dragItem, movableItem);
            }
        }

        function setTranslate(xPos, yPos, el, movableItem) {
            let scale = movableItem.style.transform.replace(/translate3d\(([^,]+)[^)]*\)/g, '').replace('scale(', '').replace(')', '');

            if (scale) {
                movableItem.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0) scale(" + scale + ")";
            }
            else {
                movableItem.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
            }
        }


        /*********************************************************
         *
         * Mobile pinch zoom js
         * Author: Eamon McKiernan
         *
         * ********************************************************/

        let pz = {};
        let zoomScale = 0;
        let maxZoom = 6;

        if (checkMobile && container) {
            pz = new PinchZoom(container, {
                draggableUnzoomed: false,
                tapZoomFactor: 3,
                minZoom: 1,
                maxZoom: maxZoom
            });

            pz.enable();
        }

        pz.getContainerCenter = function () {
            var centerX = this.container.offsetLeft + this.container.offsetWidth / 2;
            var centerY = this.container.offsetTop + this.container.offsetHeight / 2;

            return {
                x: centerX,
                y: centerY,
            };
        };

        pz.zoomTo = function (zoomFactor) {
            var center = this.getContainerCenter();
            var startZoomFactor = this.zoomFactor;
            var updateProgress = (function (progress) {
                this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
            }).bind(this);

            this.animate(this.options.animationDuration, updateProgress, this.swing);
        };

        pz.zoomIn = function (zoomFactor) {
            updateZoom('+', zoomFactor);
            if (zoomScale <= maxZoom) {
                this.zoomTo(zoomScale ? zoomScale : 2);
            }
        };

        pz.zoomOut = function (zoomFactor) {
            updateZoom('-', zoomFactor);
            if (zoomScale > 0) {
                this.zoomTo(zoomScale ? zoomScale : 2);
            }
        }

        const updateZoom = (type, zoomFactor) => {
            if (type === '+') {
                if (zoomScale < maxZoom) {
                    zoomScale = zoomScale + zoomFactor;
                }
            }
            else if (type === '-') {
                if (zoomScale === 2) {
                    pz.zoomReset();
                }
                else if (zoomScale > 2) {
                    zoomScale = zoomScale - zoomFactor;
                }
            }

            return zoomScale;
        }

        pz.zoomReset = function () {
            // Reset Zoom
            this.zoomOutAnimation();
            zoomScale = 0;
        };
    }
});